.inputAndClearButton {
  flex: 1;
  display: flex;
  align-items: center;
  margin-right: 10px;
  border-radius: 3px;
}

input.searchInput {
  caret-color: var(--navBarText);
  color: var(--navBarText);
  height: 24px;
  margin-inline-end: 5px;
  padding-inline-start: 5px;
  padding-inline-end: 5px;
  width: 100%;
}
input.searchInput::placeholder {
  color: var(--navBarSearchPlaceholder);
}

.searchInputButton {
  align-items: center;
  background-color: transparent;
  color: var(--navBarText);
  border-radius: 10px;
  border: 0;
  display: flex;
  height: 24px;
  justify-content: center;
  padding-bottom: 0;
  padding-inline-start: 1px;
  padding-inline-end: 0;
  padding-top: 0;
  min-width: 24px;
}
.searchInputButton:hover {
  background-color: var(--navBarButtonHover);
}

.searchInputButtonIcon {
  background-color: currentcolor;
}